import React, {useEffect, useState} from 'react'
import {FaTwitch, FaInstagram, FaTiktok} from 'react-icons/fa'
import { FooterContainer, FooterWrap, SocialMedia, SocialMediaWrap, SocialLogo, WebsiteRights, SocialIcons, SocialIconLink } from './FooterElements'
import {animateScroll as scroll} from 'react-scroll'

const Footer = ({ toggle }) => {

  const [scrollNav, setScrollNav] = useState(false)
  const changeNav = () => {
    if(window.scrollY >= 80){
      setScrollNav(true)
    }else{
      setScrollNav(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', changeNav)
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop()
  }

  return (
    <FooterContainer scrollNav={scrollNav}>
      <FooterWrap>
        <SocialMedia>
            <SocialMediaWrap>
                <SocialLogo to='/' onClick={toggleHome}>Bea's Miniatures</SocialLogo>
                <WebsiteRights href="https://derekdix.netlify.app/" target="_blank" aria-label="Duke Designs">Duke Design's &copy; {new Date().getFullYear()} All Rights Reserved </WebsiteRights>
                <SocialIcons>
                    <SocialIconLink href="https://www.twitch.tv/beas_miniatures" target="_blank" aria-label="Twitch">
                        <FaTwitch />
                    </SocialIconLink>
                    <SocialIconLink href="https://www.instagram.com/beas_miniatures/" target="_blank" aria-label="Instagram">
                        <FaInstagram />
                    </SocialIconLink>
                    <SocialIconLink href="https://www.tiktok.com/@pirateking920" target="_blank" aria-label="Tik-Tok">
                        <FaTiktok />
                    </SocialIconLink>
                </SocialIcons>
            </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  )
}

export default Footer
